import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { getPreviewOptionsFromCookieHeader } from '../preview-cookie';
import cmsActions from '../../actions';
import getIsProductionEnv from '../../../utils/get-is-production-env';

// Hydrates CMS preview options from the preview cookie into the store on mount (non-production only).
const useHydratePreviewOptions = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (getIsProductionEnv()) return;
    const options = getPreviewOptionsFromCookieHeader(document.cookie);
    if (options) {
      cmsActions.updatePreviewOptions(options)(dispatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useHydratePreviewOptions;
